'use client';
import { usePageTracking } from '@/shared/tracking/use-tracking';
import ErrorLayout from '../shared/pageComponents/error-layout';

export default function NotFound() {
  usePageTracking({
    key: 'page',
    payload: {
      name: '404 page',
      type: '404 page',
      previousPageName: 'no previous value',
      previousPageType: 'no previous value',
    },
  });

  return <ErrorLayout title="Page not found" description="Our system does not contain this page" />;
}
